import { create } from 'zustand'
import type { IAuthUser } from '@/shared/types/auth-user'
import { readStoredUser } from '@/shared/utils/read-stored-user'
import { useAbilityStore } from './abilityStore'

export type { IAuthUser } from '@/shared/types/auth-user'

export interface AuthStore {
  user: IAuthUser | null
  setUser: (user: IAuthUser) => void
  clearUser: () => void
}

export const useAuthStore = create<AuthStore>((set) => ({
  user: readStoredUser(),
  setUser: (user) => {
    localStorage.setItem('user', JSON.stringify(user))
    set({ user })
    useAbilityStore.getState().syncFromUser(user)
  },
  clearUser: () => {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('user')
    set({ user: null })
    useAbilityStore.getState().syncFromUser(null)
  },
}))
